export default "__VITE_ASSET__Bc1G8co$__"